import { render } from "./Orientation.vue?vue&type=template&id=3483b9ad"
import script from "./Orientation.vue?vue&type=script&lang=js"
export * from "./Orientation.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__